export default "/_next/static/assets/images/logo_schemaorg.e1f20f226ffde3ce8adabfb6965022d3.png";